<template>
  <div class="container-fuild m-0 p-0">
    <b-modal
      id="modal-userFeedback"
      size="md"
      hide-footer
      no-close-on-backdrop
      @hide="onHide"
    >
      <div class="feedBackMain" v-if="feedBackData != ''">
        <div class="row headerDiv">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <h2 class="setionTitle align-left">
              We would love to hear from you
            </h2>
          </div>
          <!-- Col-6 / -->
          <div
            v-if="feedBackData.restaurant != ''"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          >
            <div style="margin-top: 9px">
              <div class="menu_item deliverCard restaurantCard">
                <figure>
                  <img
                    :src="
                      feedBackData && feedBackData.restaurant.image
                    "
                    onerror="this.src='https://assets.cloudkitch.co.in/user_documents/Placeholder.png';"
                    height="55"
                    width="55"
                    data-src="img/menu-thumb-1.jpg"
                    alt="thumb"
                    class="lazy"
                  />
                </figure>
                <div class="deliveryCardDiv">
                  <h3 class="deliverH3">
                    {{ feedBackData.restaurant.name }} - {{
                      feedBackData.restaurant.branchName +' '+feedBackData.restaurant.city+' '+feedBackData.restaurant.state
                    }}
                  </h3>
                  <span style="font-size: 14px; color: #777"
                    >Order #<span style="color: #663333">{{
                      feedBackData.restaurant.orderID
                    }}</span></span
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- Col-6 / -->
        </div>
        <!-- Head row End -->
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            v-for="(questions, i) in feedBackData.data"
            v-bind:key="questions.id"
          >
            <div>
              <h2 class="questTitle align-left">
                <table>
                  <tr>
                    <td style="vertical-align: top;">{{ i + 1 }}.</td>
                    <td>{{ questions.title }}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <vue-star-rate
                        :rateRange="0"
                        :maxIcon="5"
                        :iconHeight="30"
                        :iconWidth="30"
                        :hasCounter="false"
                        iconColor="#F9A826"
                        iconColorHover="#F9A826"
                        iconShape="star"
                        v-on:ratingSet="starRating($event,questions.id,questions.template_id,questions.reason_group_id)"
                      >
                      </vue-star-rate>
                    </td>
                  </tr>
                  <tr v-if="lessRatings.includes(questions.id)">
                    <td></td>
                    <td>
                      Select Reason
                    </td>
                  </tr>
                  <tr v-if="lessRatings.includes(questions.id)">
                    <td></td>
                    <td style="width:100%!important">
                      <multiselect
                          v-model="resDropDown[i]"
                          :options="questions.reasons"
                          placeholder="Select any reason"
                          track-by="id"
                          label="title"
                          @input="setReasons($event,questions.id)"
                      >
                      </multiselect>
                    </td>
                  </tr>
                </table>
              </h2>
            </div>
          </div>
        </div>
        <!-- rating row end -->
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <h2 class="questTitle align-left">Comments</h2>
            <textarea
              v-model="comments"
              placeholder="Your suggestion helps others to make better choices."
              class="form-control"
              rows="2"
              cols="50"
            ></textarea>
          </div>
        </div>
        <!-- Comments end -->
        <div
          class="row"
          style="margin-top: 21px"
          v-if="
            feedBackData.restaurant != '' &&
              feedBackData.restaurant.userDataForFeedback == 0
          "
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
            style="margin-bottom: 10px"
          >
            <h2 class="questTitle align-left">Date of birth</h2>
            <date-picker
              v-model="dateOfBirth"
              format="DD-MMM-YYYY"
              :first-day-of-week="1"
              lang="en"
            ></date-picker>
          </div>
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
            style="margin-bottom: 10px"
          >
            <h2 class="questTitle align-left">Anniversary</h2>
            <date-picker
              v-model="anniversary"
              format="DD-MMM-YYYY"
              :first-day-of-week="1"
              lang="en"
            ></date-picker>
          </div>
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
            style="margin-bottom: 10px"
          >
            <h2 class="questTitle align-left">Gender</h2>
            <multiselect v-model="gender" :options="genderArr"></multiselect>
          </div>
        </div>
        <!-- personal Details end -->
      </div>

      <div v-if="isProcessing==1" class="d-flex align-items-center text-danger">
        <strong>Please wait...</strong>
        <b-spinner class="ml-auto"></b-spinner>
      </div>
      <div v-if="feedbackError!=''">
        <p class="text-danger font-weight-bold">{{feedbackError}}</p>
      </div>

      <div class="row align-center submit-button">
        <b-button
          @click="submitFeedback()"
          class="btn_1 mb_5"
          style="
            color: #000 !important;
            background: #ffc60c !important;
            padding: 14px 24px;
            font-size: 16px;
            width: 100%!important;
            border: transparent;
          "
          :disabled="isProcessing==1"
          >Submit</b-button>

      </div>
    </b-modal>
  </div>
</template>

<script>
import vueStarRate from "vue-js-star-rating";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

export default {
  props: ["feedBackData"],
  data() {
    return {
      isProcessing:0,
      userDetailsForFeedBack: 0,
      feedback: "",
      feedbackError: "",
      //    heartRatingValue:0,
      squareRatingValue: 0,
      comments: "",
      dateOfBirth: "",
      anniversary: "", 
      ratingsArr: [],
      templateID: 0,
      lessRatings:[],
      gender: "",
      genderArr: ["Male", "Female", "Other"],
      showReason:false,
      selectedReason:"",
      reasonsArr:[],
      resDropDown:[],
    };
  },
  components: {
    vueStarRate,
    DatePicker,
    Multiselect,
  },
  mounted() {
    this.generateDropDownModels();
  },
  methods: {
    generateDropDownModels(){
      if(this.feedBackData!='' && this.feedBackData.data.length > 0)
      {
        for(let i=0;i < this.feedBackData.data.length;i++)
        {
          this.resDropDown = "reason"+i;
        }
      }
    },
    starRating(rating, id,template_id,reason_group_id) {
        var starRatingobj = {
          questID: id,
          answer: rating,
          template_id : template_id,
          reason_group: reason_group_id,
          reason:"",
        };
        if(rating<=2 && !this.lessRatings.includes(id))
        {
          this.lessRatings.push(id);
        }
        if(rating>2 && this.lessRatings.includes(id)){
          let index = this.lessRatings.indexOf(id);
          this.lessRatings.splice(index,1);
        }
        if(this.ratingsArr.find(value => value.questID ==id)!== undefined)
        {
          this.ratingsArr.find(value => value.questID ==id).answer=rating;
          if(rating > 2)
          {
            this.ratingsArr.find(value => value.questID ==id).reason="";
          }
        }
        else{
          this.ratingsArr.push(starRatingobj);
      }
    },
    setReasons(reason,id){
      if(this.ratingsArr.find(value => value.questID ==id)!== undefined)
      {

          this.ratingsArr.find(value => value.questID ==id).reason=reason.title;
        }
    },

    onHide(event) {
      event.preventDefault();
      this.isProcessing=1;
      let formData = new FormData();
      formData.append("orderID", this.feedBackData.restaurant.id
          ? this.feedBackData.restaurant.id
          : 0);
      formData.append('isOrderRated',2);

      this.axios
          .post("/v2/updteOrderFeedback", formData)
          .then((response) => {
            this.isProcessing=0;
            let status = response.status;
            if (status == 200 && response.data.status == 200) {
              if(response.data.message!='')
              {
                this.$swal({
                  icon:"success",
                  title:"Order Feedback",
                  text:response.data.message
                }).then(()=>{
                  location.reload();
                });
              }
            }
          })
          .catch(error => {
            this.processing = 0;
            if(error.response.status==500){
              this.$swal({
                icon:"error",
                title:"Opps!",
                text:"Something went wrong."
              });
            }
            else{
              this.$swal({
                icon:'error',
                text:error.response.data.message
              });
            }
          });
      // }
    },
    submitFeedback() {
      this.isProcessing=1;
      this.feedbackError="";
      let postData = JSON.stringify({
        orderID: this.feedBackData.restaurant.id,
        isOrderRated: 1,
        questionRatingArr: this.ratingsArr,
        comments: this.comments,
        dateOfBirth: this.dateOfBirth,
        anniversary: this.anniversary,
        gender: this.gender,
        restaurantID:this.feedBackData.restaurant.restID,
        branchID:this.feedBackData.restaurant.restBranchID,
      });
      this.axios
          .post("/v2/addFeedbackUser", postData)
          .then((response) => {
            this.isProcessing=0;
            let status = response.status;
            if (status == 200 && response.data.status == 200) {
              this.ratingsArr = [];
                this.$swal({
                  icon:"success",
                  title:"Order Feedback",
                  text:response.data.message
                }).then(()=>{
                  location.reload();
                });
            }
            else {
              this.feedbackError=response.data.message;
            }
          })
          .catch((error) => {
            this.isProcessing=0;
            this.feedbackError=error.response.data.message;
          });
    },
  },
};
</script>
<style scoped>
.submit-button {
  margin-top: 24px;
  margin-right: auto;
  margin-left: auto;
  display: block;
}
.submit-button a {
  width: 302px !important;
}
.headerDiv {
  margin-bottom: 15px;
}
.setionTitle {
  color: #663333;
  font-size: 20px;
  margin-bottom: 0px !important;
}
.deliverCard {
  max-height: 95px;
  padding: 7px 8px;
  background: rgb(254, 241, 240);
}
.deliverCard figure {
  float: left !important;
  margin-right: 11px !important;
}
.restaurantCard figure {
  width: 50px;
  height: 50px;
  overflow: hidden;
  /* position: absolute; */
  margin: 0;
  /* left: 20px;
      top: 12px; */
  border: 1px solid #fff;
  border-radius: 3px;
}
.deliveryCardDiv {
  margin-top: 2px;
}
.deliverH3 {
  font-size: 14px;
  color: #663333;
  margin-bottom: 10px !important;
}
.questTitle {
  font-size: 13px;
  color: #663333;
  margin-bottom: 13px;
}
</style>
<style>
#modal-userFeedback___BV_modal_header_ {
  border-bottom: transparent;
}
.vue-feedback-reaction .reaction {
  /* margin: 0 auto;
    padding: 0 8px; */
  margin: 0 !important;
  padding: 0 !important;
}
.vue-feedback-reaction {
  height: 25px;
  padding-top: 5px;
}
.vue-star-rate {
  padding-top: 5px;
}
#modal-userFeedback___BV_modal_content_ {
  width: auto;
}

@media screen and (max-width: 375px) {
  .setionTitle {
    font-size: 15px;
  }

  .deliverCard {
    max-height: 85px !important;
    padding: 12px 15px !important;
  }

  .restaurantCard figure {
    width: 60px !important;
    height: 60px !important;
  }

  /* .strip {
    margin-bottom: 0px!important;
  } */

  .vue-reaction {
    position: relative;
    display: contents;
  }

  .vue-reaction img {
    height: 35px;
    margin: 0 5px;
  }

  .questTitle {
    margin-bottom: 15px;
  }
}
</style>
